import { DevicesListRoutePath } from "../../";
import { RoutePath } from "#src/utils/route";

export const DevicesDetailRoutePath = DevicesListRoutePath.concat(
  new RoutePath({
    title: "Device Detail",
    path: "/:deviceId/details",
  })
);
